import { render, staticRenderFns } from "./IniciarAtendimento.vue?vue&type=template&id=a558a09a&scoped=true&"
import script from "./IniciarAtendimento.vue?vue&type=script&lang=js&"
export * from "./IniciarAtendimento.vue?vue&type=script&lang=js&"
import style0 from "./IniciarAtendimento.vue?vue&type=style&index=0&id=a558a09a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a558a09a",
  null
  
)

export default component.exports